const doc = [({"apply":"Appliquer", "charged":"Payé le", "clear":"Effacer", "empty":"Vide", "paid":"Payé", "payment_period":"Délai de paiement", "search":"Rechercher"})];
module.exports = doc.length <= 1 ? doc[0] : doc;